module.exports = __webpack_public_path__ + "static/media/Saturday.a4850ac3.webp";